import styled from 'styled-components';
import { Dimensions } from 'components/visuals';

export const MessageNotificationWrapper = styled.div`
  text-align: left;
  margin-bottom: ${Dimensions.unit}px;
`;
